<template>
  <!-- Modal Definir Modo Navegação -->
  <div id="ModalDefinirModoNavegacao" class="modal bottom-sheet">
    <div class="modal-content ">
      <div
        class="btn waves-effect waves-light cor-primaria-bg" @click="NovoCadastro()" style="padding: 0; width: 100%">
        <div class="">
          <div class="col s12" style="margin-left: auto;
    margin-right: auto; font-weight: bold">Acessar com seu Login
          </div>
        </div>
      </div>
      <div class="btn waves-effect waves-light btn-flat" @click="Menu()"
           style="padding: 0; padding-top: 5px;width: 100%">
        <div class="col s12" style="margin-left: auto; margin-right: auto; font-weight: bold">Acessar como Convidado
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalDefinirModoNavegacao",
  mounted() {
    $(document).ready(function () {
      $('#ModalDefinirModoNavegacao').modal();
    });
  },
  methods: {
    NovoCadastro() {
      this.$router.push("/" + this.$store.state.empresa_url + "/login");
    },
    Menu() {
      this.$router.push("/" + this.$store.state.empresa_url + "/menu");
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/ModalDefinirModoNavegacao.vue